import { render } from "./InputImageFile.vue?vue&type=template&id=cb8172b4&scoped=true&ts=true"
import script from "./InputImageFile.vue?vue&type=script&lang=ts"
export * from "./InputImageFile.vue?vue&type=script&lang=ts"

import "./InputImageFile.vue?vue&type=style&index=0&id=cb8172b4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb8172b4"]])

export default __exports__